<template>
    <div id="AttendanceStatQuery">
        <div id="scrollBody">
            <div v-if="bannerShow">
                <div class="banner"></div>
                <div class="banner-title">
                    <p v-cloak>
                        {{this.xy.moment().format(add(new Date(), 'd', 0), 'dd')}}
                    </p>
                    <div class="banner-title-div">
                        <p v-cloak>
                           星期{{part(new Date(),'w')}}
                        </p>
                        <p v-cloak>
                            {{format(add(new Date(), 'd', 0), 'MM.yyyy')}}
                        </p>
                    </div>
                </div>
            </div>
            <div class="search">
                <van-cell-group>
                    <van-field
                        clearable
                        type="text"
                        label="请选择校区："
                        placeholder="请选择校区"
                        v-model="campusMsg"
                        @click="campus()"
                    />
                    <van-field
                        type="text"
                        label="请选择年级："
                        placeholder="请选择年级"
                        v-model="gradeMsg"
                        @click="grade()"
                    />
                    <van-field
                        clearable
                        type="text"
                        label="开始时间："
                        left-icon="play-circle"
                        placeholder="请选择开始时间"
                        v-model="startMsg"
                        @click="showStartDate"
                    />
                    <van-field
                        type="text"
                        label="结束时间："
                        left-icon="play-circle"
                        placeholder="请选择结束时间"
                        v-model="endMsg"
                        @click="showEndDate"
                    />
                    <p style="font-size:14px;color: rgb(153, 153, 153);padding: 10px 0 25px 25px;">请选择要统计的学生范围和时间范围</p>
                </van-cell-group>
            </div>
            <div class="chart" v-if="!bannerShow" style="margin-top:10px;background-color: #fff;height: auto;">
                <p style="text-align:right;padding:10px 15px 10px 0;color:#AAAAAA;">数据截止到：今日{{format(new Date(), 'HH:mm:ss')}}</p>
                <p style="text-align:left;padding:10px 0 10px 15px;font-size:16px;font-weight: bold;">
                    {{campusMsg}}
                </p>
                <div style="text-align: center;">
                    <van-circle
                    v-model="currentRate"
                    :rate=chartCamData[0].AttTypeNum
                    :speed="100"
                    size="170px"
                    layer-color="#ebedf0"
                    :stroke-width="60"
                    >
                        <p style="color:#999999; font-size:13px;text-align:center;margin-top:25%;">应到：{{chartCamData[0].AttTypeNum}}人</p>
                        <p style="color:#333333;font-size:40px; font-weight:bold;text-align:center;margin:5px;">{{chartCamData[0].AttTypeNum.toFixed(0) + '%'}}</p>
                        <p style="color:#4991F6; font-size:15px;text-align:center; font-weight:bold">{{chartCamData[0].AttTypeName ==='正常' ?"出勤率":chartCamData[0].AttTypeName}}</p>
                    </van-circle>
                    <br/>
                    <div class="smallChart">
                        <div  v-for="(item,index) in chartCamData" :key="index">
                            <van-circle
                            v-model="currentRate"
                            :rate=item.AttTypeNum
                            :speed="100"
                            size="70px"
                            layer-color="#ebedf0"
                            :stroke-width="60"
                            >
                                <p style="color:#999999; font-size:13px;text-align:center;margin-top:25%;">{{item.AttTypeNum}}</p>
                            </van-circle>
                            <p>{{item.AttTypeName}}人次</p>
                        </div>
                    </div>

                </div>

            </div>
            <div class="chart" v-if="!bannerShow" style="margin-top:10px;background-color: #fff;height: auto;">
                <p style="text-align:left;padding:10px 0 10px 15px;font-size:16px;font-weight: bold;">
                    {{gradeMsg.length > 0 ?gradeMsg:"2019级高中"}}
                </p>
                <div style="text-align: center;">
                    <div class="smallChart">
                        <div  v-for="(item,index) in chartCamData" :key="index">
                            <p style="display:inline-block;width: 50px;height: 43px;line-height: 27px;font-size: 27px;">{{item.AttTypeNum}}</p>
                            <p>{{item.AttTypeName}}人次</p>
                        </div>
                    </div>

                </div>

            </div>
        </div>

        <van-popup v-model="campusShow" position="bottom" :style="{ height: '45%' }">
            <div class="campusContent" v-for="(item,index) in campusData" :key="index" @click="choseCampus(item)">
            {{item.label}}
            </div>
        </van-popup>
        <van-popup v-model="gradeShow" position="bottom" :style="{ height: '45%' }">
            <div class="campusContent" v-for="(item,index) in gradeData" :key="index" @click="choseGrade(item)">
            {{item.label}}
            </div>
        </van-popup>
        <van-popup v-model="startDate" position="bottom" :style="{ height: '45%' }">
            <van-datetime-picker
                @cancel="cancelPicker"
                @confirm="confirmPickerStart"
                v-model="currentDate"
                type="date"
                :formatter="formatter"
                :max-date="maxDate"
            />
        </van-popup>
        <van-popup v-model="endDate" position="bottom" :style="{ height: '45%' }">
            <van-datetime-picker
                @cancel="cancelPicker"
                @confirm="confirmPickerEnd"
                v-model="currentDate"
                type="date"
                :formatter="formatter"
                :max-date="maxDate"
            />
        </van-popup>
        <div v-if="bannerShow" class="bottom-btn">
            <van-button type="default" @click="search">搜索</van-button>
        </div>

    </div>
</template>
<script>
import { Toast } from 'vant';

export default {
  data() {
    return {
      bannerShow: true,
      campusShow:false,
      campusData:[],
      campusMsg:'',
      gradeId:'',
      gradeType:'',
      gradeShow:false,
      gradeData:[],
      gradeMsg:'',
      startDate:false,
      currentDate: new Date(), // 开始时间不能超过当前时间,
      maxDate: new Date(2020, 12, 31),
      startMsg: this.xy.moment().format('yyyy-MM-dd'),
      endDate:false,
      endMsg: this.xy.moment().format('yyyy-MM-dd'),
      currentRate:0,
      chartCamData:[],
      yearId:'',
      chartCamData2:[]

    }
  },
  computed: {

  },
  created() {
    this.getCampus()
  },
  methods: {
    //校区下拉框
    async getCampus() {
      this.xy.loading()
      var _this = this;
      let res = await this.xyapi.get(this.$store.state.apiPath +"/api/AttsLesson/GetOrgNodeList",{
        id: 0, type: ''
      })
      if(res.success === true){
        _this.xy.unloading()
        if(res.data.length>0){
          _this.campusData = res.data
        }else{
          Toast.fail('暂无校区数据')
        }
      }else if (res.success === false){
        _this.xy.unloading()
        Toast.fail(res.msg)
      }
    },
    campus() {
      this.campusShow = true
      this.gradeMsg = ''
      this.gradeData = []
    },
    choseCampus(i) {
      this.campusMsg = i.label
      this.gradeId = i.value
      this.gradeType = i.nodetype
      this.campusShow = false
      //校区统计
      this.getColumnsCampus()
    },
    //年级下拉框
    async getGrade() {
      this.xy.loading()
      var _this = this;
      let res = await this.xyapi.get(this.$store.state.apiPath +"/api/AttsLesson/GetOrgNodeList",{

        id: _this.gradeId, type: _this.gradeType
      })
      if(res.success === true){
        _this.xy.unloading()
        if(res.data.length>0){
          _this.gradeData = res.data
          this.gradeShow = true
        }else{
          Toast.fail('暂无'+_this.campusMsg+'的年级数据')
        }
      }else if (res.success === false){
        _this.xy.unloading()
        Toast.fail(res.msg)
      }
    },
    grade() {
      this.getGrade()
    },
    choseGrade(i) {
      this.gradeMsg = i.label
      this.gradeShow = false
      this.yearId = i.value
      this.getColumnsYear()
    },
    showStartDate() {
      this.startDate = true;
    },
    showEndDate() {
      this.endDate = true;
    },
    formatter(type, value) {
      // 格式化选择器日期
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      }
      return value;
    },
    cancelPicker() {
      // 选择器取消按钮点击事件
      this.startDate = false;
      this.endDate = false;
    },
    confirmPickerStart(value) {
      // 确定按钮，时间格式化并显示在页面上
      var date = value;
      var m = date.getMonth() + 1;
      var d = date.getDate();
      if (m >= 1 && m <= 9) {
        m = "0" + m;
      }
      if (d >= 0 && d <= 9) {
        d = "0" + d;
      }
      var timer = date.getFullYear() + "-" + m + "-" + d;
      this.startMsg = timer;
      this.startDate = false;
    },
    confirmPickerEnd(value) {
      // 确定按钮，时间格式化并显示在页面上
      var date = value;
      var m = date.getMonth() + 1;
      var d = date.getDate();
      if (m >= 1 && m <= 9) {
        m = "0" + m;
      }
      if (d >= 0 && d <= 9) {
        d = "0" + d;
      }
      var timer = date.getFullYear() + "-" + m + "-" + d;
      this.endMsg = timer;
      this.endDate = false;
    },
    //校区统计
    async getColumnsCampus() {
      // this.xy.loading()
      let res = await this.xyapi.get(this.$store.state.apiPath +"/api/AttsLesson/GetTypeForColumn")
      if(res.success === true){
        this.xy.unloading()
        if(res.data.length>0){
          this.chartCamData = res.data
        }
      }else if (res.success === false){
        this.xy.unloading()
        Toast.fail(res.msg)
      }
    },
    search() {
      if(this.chartCamData.length>0 || this.chartCamData2.length>0) {
        this.bannerShow = false
      }else{
        Toast('请先选择有效校区')
      }
    },
    //年级统计
    async getColumnsYear() {
      console.log(this.yearId)
      this.xy.loading()
      let res = await this.xyapi.get(this.$store.state.apiPath +"/api/AttStatistics/GetForYear",{
        studentGradeForStudentYearID: this.yearId,
        startDate: this.startMsg,
        endDate: this.endMsg,
      })
      if(res.success === true){
        this.xy.unloading()
        if(res.data.length>0){
          this.chartCamData2 = res.data
        }
      }else if (res.success === false){
        this.xy.unloading()
        Toast.fail(res.msg)
      }
    },

  },
}
</script>
<style lang="less">
.banner {
    width: 100%;
    height: 245px;
    background: url("../../../../assets/common/banner.png") no-repeat center;
    background-size: cover;
}
.banner-title {
    height: 84px;
    background: linear-gradient(180deg,rgba(253,184,53,1) 0%,rgba(255,187,63,1) 99%);
    display: flex;
    padding-left: 40px;
    p {
        font-weight: bold;
        font-size: 72px;
        margin-right: 25px;
        color:#fff;
    }
    .banner-title-div {
        margin-top: 14px;
        p {
            font-size: 26px;
            line-height: 32px;
            color: #fff;
        }
    }
}
.campusContent{
    width: 100%;
    text-align: center;
    font-size: 28px;
    color: #555;
    line-height: 100px;
}
.bottom-btn {
    width: 100%;
    position: fixed;
    left: 0;
    // bottom: 0;
    z-index: 99;
    .van-button {
      display: block;
      width: 100%;
      height: 100px;
      border-radius:10px;
      line-height: 100px;
      color: #fff;
      font-weight: 700;
      font-size: 30px;
      font-weight: 400;
      margin: 10px auto 15px;
      text-align: center;
      background: #4196ff !important;
    }
}
.smallChart{
    display: flex;
    flex-wrap: wrap;
    div{
        width:18%;
        float:left;
        margin: 2% 3%;
    }
}

</style>
